module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "header"
  }, [(_vm.showBack) ? _c('a', {
    staticClass: "btn-back",
    attrs: {
      "href": "javascript:history.back()"
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("CNODE 社区")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e397be64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 52
// module chunks = 0